//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useEffect, useRef, useState } from "react";
import dayjs from "dayjs";

import { useTheme } from '@mui/material/styles';
import {
  Box,
  Button,
  CardContent,
  InputBase,
  Tooltip,
} from '@mui/material';
import {
  ExpandLess, ExpandMore,
} from '@mui/icons-material';

// === COMPONENTS ===
import { Spacer } from "components/Spacer";
import Styled from "components/Styled/Styled";

// === API ===
import { emit, updateAuditField } from "api/prokey/prokey.websocket";

//#endregion

//-----------------------------------------------------------------
export function Field({field, file_id, rule_id, numcode}) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme         = useTheme();
  const ref_container = useRef();

  const content_original = field.Entries     ? field.Entries[0] .Content       : '';
  const header           = field.DisplayInfo ? field.DisplayInfo.DisplayHeader : '';
  const validation_color = field.passed ? theme.palette.success.main : theme.palette.error.main;
  const length           = field.DisplayInfo ? Math.max(field.DisplayInfo.Length * 12, 20 ) : '100%' ;

  const [ show , setShow ] = useState( false );

  const expand_icon = show ? <ExpandLess fontSize='large' /> : <ExpandMore fontSize='large' />;

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {
      height: '100%',
      flexShrink: 0,
      backgroundColor: theme.palette.background.primary[theme.palette.mode],
    },
    header: {
      paddingTop    : '0rem',
      paddingBottom : '0rem',
      fontSize: '85%',
      wordBreak: 'break-word',
      backgroundColor: theme.palette.background.primary[theme.palette.mode],
      width        : length,
      minWidth     : '200px'
    },
    content: {
      display: 'flex',
    },
    input: {
      borderStyle  : 'solid',
      borderWidth  : '2px',
      borderColor  : validation_color,
      borderRadius : '5px',
      paddingLeft  : '0.5rem',
      width        : length,
      minWidth     : '110px'
    },
  }

  const
    CONTAINER = {
      sx      : _styles.container,
      ref     : ref_container,
      variant : 'primary',
      onClick: () => { 
        emit( 'IMAGE', field.image );
        // Give image time to load
        setTimeout( () => emit( 'FILE_FIELD', { ...field, is_selected: true } ) , 250)
      },
    },
    HEADER = {
      sx       : _styles.header,
      children : field.document.NumCode ? field.document.NumCode + ' - ' + header : header,
    },
    CONTENT = {
      sx: _styles.content,
    },
    INPUT = {
      sx: _styles.input,
      disabled: field.isReadOnly,
      defaultValue: content_original,
      onKeyDown,
    };

  //#endregion

  //#region [EFFECT] 

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onKeyDown(event) {
    //-----------------------------------------------------------------
    if (event.key === 'Enter' && event.ctrlKey) {
      // force accept
    } else if (event.key === 'Enter') {
      updateAuditField( file_id, rule_id, field.id, numcode, {
        content : event.target.value      ,
        state   : field.Entries[0].State  ,
        left    : field.Entries[0].Left   ,
        top     : field.Entries[0].Top    ,
        right   : field.Entries[0].Right  ,
        bottom  : field.Entries[0].Bottom ,
      } )
    } else if (event.key === 'Tab' && !event.shiftKey) {
      event.preventDefault();

    }
  }


  //-----------------------------------------------------------------
  function onClick_OpenHistory( event ) {
    //-----------------------------------------------------------------
    try {
      setShow( !show );
    } catch (error) {
      console.warn(error);
    }
  }

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
        <Box { ...CONTAINER } >
          <CardContent { ...CONTENT } >
            <InputBase { ...INPUT } />
            <Tooltip title={<h2 style={{margin: 0}}>Field History</h2>} placement='bottom-start'>
              <Button sx={{ padding: '0', minWidth: '30px',}}  disabled={[0,undefined].includes( field.history)} onClick={onClick_OpenHistory} >
                {field.id === -1 ?  <Spacer /> : expand_icon}
              </Button>
            </Tooltip>
          </CardContent>
          { show ? displayHistory() : null }
        </Box>
    )
  }

  //-----------------------------------------------------------------
  function displayHistory() {
    //-----------------------------------------------------------------
    if( field.history?.length <= 0 || field?.history == null ) {
      return (
      <Styled styles={[{padding:'0 0 12px 12px'}]}>
        No field history.
      </Styled>
      )
    }
    const history = field.history?.map( (x,index)=>(
      [
        <div key={'stage-'+index} style={{ minHeight: '30px' }}>{x.stage||''}</div>,
        <div key={'value-'+index} style={{ wordBreak: 'break-word' }}>{x.value||''}</div>,
        <div key={'user-' +index} style={{ minHeight: '30px' }}>{x.user||''}</div>,
        <div key={'date-' +index} style={{ }}>{dayjs(x.timestamp).format('YYYY-MM-DD HH:mm A')||''}</div>,
      ]
    ))||null
    return (
      <Styled styles={[{display:'grid', gridTemplateColumns: '60px minmax(50px, auto) minmax(50px, auto) auto', gridTemplateRows: `30px repeat( ${history?.length-1||0}, minmax( 30px, auto ) )`, columnGap: '12px', rowGap: '4px'},{padding: '0 0 12px 12px'}, { overfow: 'auto' }, { justifyContent: '' }, ]}>
        {<><div>Stage</div><div>Value</div><div>User</div><div>Date</div></>}
        {history}
      </Styled>
    )
  }

  //#endregion

  return display();
}